<template>
  <v-app>
    <v-content class="pa-0">
      <v-layout justify-center fluid fill-height>
        <v-flex text-center>
          <section id="contact" class="pt-10 bg_color">
            <h1>お問い合わせ</h1>
            <div>
              <v-form id="form" ref="form" v-model="contactFormValidation.valid" lazy-validation>
                <ul class="pa-0">
                  <li class="left">
                    <strong>名前</strong>
                    <span class="require">✳︎</span>
                  </li>
                  <li class="right">
                    <div class="w-half">
                      <v-text-field
                        name="family"
                        placeholder="山田"
                        class="w-full"
                        v-model="contactForm.family"
                        :rules="contactFormValidation.familyRules"
                        required
                      ></v-text-field>
                    </div>
                    <div class="w-half">
                      <v-text-field
                        name="first"
                        placeholder="太郎"
                        class="w-full"
                        v-model="contactForm.first"
                        :rules="contactFormValidation.firstRules"
                        required
                      ></v-text-field>
                    </div>
                  </li>
                  <li class="left">
                    <strong>会社名</strong>
                    <span class="require">✳︎</span>
                  </li>
                  <li class="right">
                    <v-text-field
                      name="company"
                      placeholder="○○○○株式会社"
                      class="w-full"
                      v-model="contactForm.company"
                      :rules="contactFormValidation.companyRules"
                    ></v-text-field>
                  </li>
                  <li class="left">
                    <strong>メールアドレス</strong>
                    <span class="require">✳︎</span>
                  </li>
                  <li class="right">
                    <v-text-field
                      name="email"
                      type="email"
                      placeholder="exmple@glc.com"
                      class="w-full"
                      v-model="contactForm.email"
                      :rules="contactFormValidation.emailRules"
                      required
                    ></v-text-field>
                  </li>
                  <li class="left">
                    <strong>電話番号</strong>
                  </li>
                  <li class="right">
                    <v-text-field
                      name="tel"
                      type="tel"
                      placeholder="000-0000-0000"
                      class="w-full"
                      v-model="contactForm.tel"
                    ></v-text-field>
                  </li>
                  <li class="left">
                    <strong>お問い合わせ内容</strong>
                  </li>
                  <li class="right">
                    <v-textarea
                      name="content"
                      placeholder="お問い合わせ内容"
                      class="w-full"
                      v-model="contactForm.content"
                      :rules="contactFormValidation.contentRules"
                    ></v-textarea>
                  </li>
                </ul>
                <v-btn
                  :loading="contactForm.loading"
                  :disabled="!contactFormValidation.valid"
                  @click="sendMail()"
                  color="#FFFFFF"
                  class="btn"
                >上記内容で送信する</v-btn>
              </v-form>
            </div>
            <template>
              <div class="text-center ma-2">
                <v-snackbar
                  v-model="showMessage.show"
                  :color="showMessage.color"
                  :timeout="showMessage.timeout"
                  top
                  vertical
                >
                  {{ showMessage.message }}
                  <v-btn top text @click="showMessage.show = false">Close</v-btn>
                </v-snackbar>
              </div>
            </template>
          </section>
        </v-flex>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Contact',
  data () {
    return {
      errors: [],
      contactForm: {
        family: '',
        first: '',
        email: '',
        company: '',
        tel: '',
        content: '',
        loading: false,
        type: 'お問い合わせを受け付けました。'
      },
      contactFormValidation: {
        valid: false,
        familyRules: [v => !!v || '名字を入力してください'],
        firstRules: [v => !!v || '名前を入力してください'],
        emailRules: [
          v => !!v || 'メールアドレスを入力してください',
          v => /.+@.+\.+/.test(v) || '正しいメールアドレスを入力してください'
        ],
        companyRules: [v => !!v || '会社名を入力してください'],
        contentRules: [v => !!v || 'お問い合わせ内容を入力してください']
      },
      showMessage: {
        show: false,
        color: '',
        message: '',
        timeout: 6000
      }
    }
  },
  methods: {
    sendMail: function () {
      if (this.$refs.form.validate()) {
        this.contactForm.loading = true
        const url =
          'https://gm5mtd20ml.execute-api.ap-northeast-1.amazonaws.com/default/sendMail';

        axios
          .post(url, { data: { ...this.contactForm, site_name: 'SmartMirror' } })
          .then(() => {
            this.formReset()
            this.showMessages(
              'info',
              '送信完了しました。お問い合わせありがとうございます。'
            )
          })
          .catch(err => {
            this.showMessages(
              'error',
              '送信に失敗しました。時間をおいて再度お試しください。'
            )
            console.log(err)
          })
          .finally(() => {
            this.contactForm.loading = false
          })
      }
      event.preventDefault()
    },
    showMessages: function (color, message) {
      this.showMessage.message = message
      this.showMessage.color = color
      this.showMessage.show = true
    },
    formReset: function () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #225086;
}
.require {
  color: #de0000;
  font-size: 14px;
}
.w-half {
  width: calc(50% - 5px);
  display: inline-table;
}
h1 {
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0px;
  -webkit-font-smoothing: antialiased !important;
  font-family: 'Noto Sans JP', sans-serif;
  font-feature-settings: "none";
}
strong {
  font-size: 14px;
  -webkit-font-smoothing: antialiased !important;
}
.w-full {
  width: 100%;
  margin: 5px 0;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
#contact {
  margin-top: 64px;
  font-family: 'Noto Sans JP', sans-serif;
  line-height: 32px;
}
#contact.bg_color {
  background-color: #fff;
}
#form {
  max-width: 900px;
  margin: 0px auto;
  padding: 50px 20px 0px 20px;
}
#form ul {
  display: block;
}
#form ul li {
  text-align: left;
  margin-bottom: 10px;
  clear: both;
}
#form ul li input {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #707070;
  font-size: 16px;
}
#form .v-input {
  font-size: 14px;
}
#form .left {
  display: inline-block;
  width: 33.3%;
  margin-bottom: 0;
}
#form .right {
  display: inline-block;
  width: 66.6%;
}
@media screen and (max-width: 759px) {
  #form .left,
  #form .right {
    display: inline-block;
    width: 100%;
  }
}
.btn {
  border: 1px solid #000000 !important;
  border-radius: 0px !important;
  width: 160px !important;
  height: 49px !important;
  box-shadow: none;
  width: 300px;
  text-align: center;
  font-size: 15px;
  margin: 40px auto;
  padding: 16px 12px !important;
  font-weight: 400 !important;
}
.btn:hover {
  color: #ffffff !important;
  background-color: #0071e3 !important;
  border: solid 1px #0071e3 !important;
  cursor: pointer;
}
.btn:disabled {
  border-color: #888;
}
.primary {
  background-color: #0073ff;
  border-color: #0073ff;
}
.primary {
  color: #fff;
}
@media screen and (max-width: 1000px) {
  h1 {
    font-size: 24px;
  }
}
@media screen and (max-width: 750px) {
  .w-half {
    width: 100%;
    margin-left: 0px;
  }
  .w-half:nth-child(odd) {
    margin-left: 0px;
  }
}
@media screen and (min-width: 751px) {
  .w-half:nth-child(even) {
    margin-left: 10px;
  }
  .w-half:nth-child(odd) {
    float: left;
  }
}

</style>
